<template>
  <div class="ai-analyzer-container" v-if="show">
    <div class="analyzer-content">
      <div class="brain-waves">
        <div v-for="n in 3" :key="n" class="wave" :style="{ animationDelay: `${n * 0.2}s` }"></div>
      </div>
      <div class="thinking-dots">
        <span v-for="n in 3" :key="n" :style="{ animationDelay: `${n * 0.3}s` }">•</span>
      </div>
      <div class="status-text">{{ currentStatus }}</div>
      <div class="progress-bar">
        <div class="progress-fill" :style="{ width: `${progress}%` }"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AITaskAnalyzer',
  
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      progress: 0,
      statusIndex: 0,
      currentStatus: '',
      statusMessages: [
        'Reading your note',
        'Identifying tasks',
        'Checking for duplicates',
        'Processing task details',
        'Almost there'
      ],
      statusInterval: null,
      progressInterval: null
    }
  },

  watch: {
    show(newVal) {
      if (newVal) {
        this.startAnimation();
      } else {
        this.clearIntervals();
      }
    }
  },

  mounted() {
    if (this.show) {
      this.startAnimation();
    }
  },

  beforeUnmount() {
    this.clearIntervals();
  },

  methods: {
    startAnimation() {
      // Reset values
      this.progress = 0;
      this.statusIndex = 0;
      this.currentStatus = this.statusMessages[0];
      
      // Update status message every 2.5 seconds
      this.statusInterval = setInterval(() => {
        this.statusIndex = (this.statusIndex + 1) % this.statusMessages.length;
        this.currentStatus = this.statusMessages[this.statusIndex];
      }, 2500);

      // Increment progress smoothly
      this.progressInterval = setInterval(() => {
        if (this.progress < 90) {
          this.progress += 0.5;
        }
      }, 100);
    },

    clearIntervals() {
      clearInterval(this.statusInterval);
      clearInterval(this.progressInterval);
    }
  }
}
</script>

<style scoped>
.ai-analyzer-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
}

.analyzer-content {
  background: #1a1a1a;
  border-radius: 16px;
  padding: 2rem;
  width: 90%;
  max-width: 400px;
  text-align: center;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.brain-waves {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 1rem;
}

.wave {
  width: 4px;
  height: 20px;
  background: #4f46e5;
  border-radius: 2px;
  animation: wave 1s ease-in-out infinite;
}

.thinking-dots {
  font-size: 2rem;
  color: #4f46e5;
  height: 2rem;
  margin-bottom: 1rem;
}

.thinking-dots span {
  display: inline-block;
  animation: pulse 1s ease-in-out infinite;
  margin: 0 2px;
}

.status-text {
  color: #fff;
  font-size: 1.1rem;
  margin-bottom: 1rem;
  min-height: 1.5em;
  transition: opacity 0.3s;
}

.progress-bar {
  width: 100%;
  height: 4px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #4f46e5, #818cf8);
  transition: width 0.3s ease-out;
}

@keyframes wave {
  0%, 100% {
    height: 20px;
  }
  50% {
    height: 40px;
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 0.3;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
  }
}

/* Mobile responsiveness */
@media (max-width: 640px) {
  .analyzer-content {
    width: 95%;
    padding: 1.5rem;
  }
  
  .brain-waves {
    height: 50px;
  }
  
  .status-text {
    font-size: 1rem;
  }
}
</style>
